<template>
    <section>
        <Header title="Dienstverleners" show-back-button></Header>
        <v-container class="pt-0 pt-md-4">
            <p v-if="isLoading" class="text-center my-7"><v-icon large color="primary">fal fa-spinner-third fa-spin</v-icon></p>
            <v-breadcrumbs :items="breadcrumbs" class="px-0"></v-breadcrumbs>
            <v-row v-if="!isLoading">
                <v-col class="col-12 col-md-4 col-lg-3 px-0 px-md-4 pb-0">
                    <FilterPopup></FilterPopup>
                    <FilterList class="d-none d-md-block"></FilterList>
                </v-col>
                <v-col class="col-12 col-md-8 col-lg-9">
                    <OrganisationList></OrganisationList>
                </v-col>
            </v-row>
        </v-container>
    </section>
</template>

<script>
import Header from "@/components/layout/Header";
import OrganisationList from "@/components/organisation/OrganisationList";
import FilterList from "@/components/organisation/FilterList";
import {mapGetters, mapState} from "vuex";
import FilterPopup from "../components/organisation/FilterPopup";

export default {
    name: 'Organisations',
    components: {
        FilterPopup,
        FilterList,
        OrganisationList,
        Header,
    },
    data: () => ({
        isLoading: true,
    }),
    watch: {
        filters: {
            handler () {
                if (!this.isLoading) {
                    this.updateRouteQuery();
                }
            },
            deep: true,
        },
        organisationPage () {
            if (!this.isLoading) {
                this.updateRouteQuery();
            }
        },
        '$route.query' () {
            // Alleen bij een ander type de filters resetten: updateOrganisationType wist de
            // facetfilters, waardoor het aantal resultaten wijzigt en de pagina terugspringt naar 1.
            const type = this.$route.query.type || null;
            if (type !== this.filters.organisationType) {
                this.$store.dispatch('organisation/updateOrganisationType', type);
            }
            this.initializeSelectedOrganisationTypes();
            this.initializeSelectedFacets();
            this.$store.dispatch('organisation/updateOrganisationPage', parseInt(this.$route.query.page || 1));
        },
    },
    mounted () {
        this.$store.dispatch('organisation/updateOrganisations')
            .catch(e => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Organistaties konden niet worden opgehaald' });
            })
            .finally(() => {
                this.$store.dispatch('organisation/updateOrganisationType', this.$route.query.type || null);
                this.initializeSelectedOrganisationTypes();
                this.initializeSelectedFacets();

                this.$store.dispatch('organisation/updateSearchQuery', this.$route.query.query ? this.$route.query.query : null);
                this.$store.dispatch('organisation/updateOrganisationPage', parseInt(this.$route.query.page ? this.$route.query.page : 1));

                this.isLoading = false;
            });
    },
    computed: {
        ...mapState({
            filters: state => state.organisation.filters,
            organisationPage: state => state.organisation.organisationPage,
            isLoggedIn: state => state.auth.isLoggedIn,
        }),
        ...mapGetters('organisation', ['visibleFacets']),
        facets () { return this.visibleFacets; },
        breadcrumbs () {
            const crumbs = [];

            // De Dashboard-kruimel verwijst naar een login-only pagina; verberg hem voor uitgelogde bezoekers.
            if (this.isLoggedIn) {
                crumbs.push({
                    text: 'Dashboard',
                    disabled: false,
                    exact: true,
                    to: { name: 'Home' },
                });
            }

            crumbs.push({
                text: 'Dienstverleners',
                disabled: true,
                exact: true,
                to: { name: 'Organisations' },
            });

            return crumbs;
        },
    },
    methods: {
        initializeSelectedOrganisationTypes() {
            const allowedTypes = ['professional', 'sustainable_employability'];
            const types = this.$route.query.types
                ? ('' + this.$route.query.types).split(',').filter(type => allowedTypes.includes(type))
                : [];

            this.$store.dispatch('organisation/updateOrganisationTypeFilter', types);
        },
        initializeSelectedFacets() {
            const query = this.$route.query;
            this.facets.forEach(facet => {
                let choices = [];

                const index = 'filter' + facet.id;
                if (query[index]) {
                    ('' + query[index]).split(',').forEach(id => {
                        const choice = facet.choices.find(c => c.id === parseInt(id));
                        if (choice) {
                            choices.push(choice.id);
                        }
                    });
                }

                this.$store.dispatch('organisation/updateFacetFilter', { facet, choices });
            });
        },
        updateRouteQuery () {
            let query = {
                page: ''+this.organisationPage,
            };

            if (this.filters.searchQuery) {
                query.query = this.filters.searchQuery;
            }

            if (this.filters.organisationType) {
                query.type = this.filters.organisationType;
            }

            if (this.filters.organisationTypes && this.filters.organisationTypes.length > 0) {
                query.types = this.filters.organisationTypes.join(',');
            }

            this.facets.forEach(facet => {
                const selectedChoices = this.filters.facetChoices[facet.id];
                if (selectedChoices.length > 0) {
                    query['filter'+facet.id] = selectedChoices.join(',');
                }
            });

            if (JSON.stringify(query) === JSON.stringify(this.$route.query)) {
                return;
            }

            this.$router.replace({ name: 'Organisations', query: query });
        },
    },
}
</script>
